// @flow

import $ from 'jquery'

import OrderValidation from './OrderValidation'
import Dropdown from '../components/Dropdown'

type InputEvent = SyntheticInputEvent<HTMLInputElement> | { target: HTMLInputElement }
type FieldType = 'postal_code' | 'city'
type ActionType = 'cities' | 'streets'
type SuggestionResult = {
  success: ?boolean,
  [ActionType]: ?Array<string>,
}

export default class OrderSuggestions {
  static _getSuggestionsCacheKey (type: ActionType, data: Object): string {
    return `vol_suggestions_${type}_${Object.keys(data).sort().map(key => data[key]).join('_')}`
  }

  static async _getSuggestions (type: ActionType, data: Object): Promise<SuggestionResult> {
    const cacheKey = OrderSuggestions._getSuggestionsCacheKey(type, data)
    const cachedSuggestions = localStorage.getItem(cacheKey)

    // Ignore Local-Storage-Cache
    // 
    //if (cachedSuggestions) {
      //return { success: true, [type]: JSON.parse(cachedSuggestions) }
    //}

    let response = {}

    try {
      response = await $.post(
        `/bestellprozess?tx_voltego_orders%5Baction%5D=${type}&tx_voltego_orders%5Bcontroller%5D=Ajax&type=1335898897`,
        data
      )
    }
    catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }

    // Ignore Local-Storage-Cache
    //
    //if (response.success && response[type] && response[type].length) {
      //localStorage.setItem(cacheKey, JSON.stringify(response[type]))
    //}

    return response
  }

  static _removeDataList (fieldKey: string) {
    const field = $(`input[name="${fieldKey}"]`)
    const listId = `datalist_${fieldKey}`

    field.removeAttr('list')
    $(`#${listId}`).remove()
  }

  static async initPreSupplierDropdown($fields) {
    let fieldKey = $fields.get(0).id

    let query = "";
    const { success, suppliers } = await OrderSuggestions._getSuggestions('prevprovider', { query: query })

    const supplierMap = {}
    suppliers.forEach(e=> {
      supplierMap[e]=e
    })
    Dropdown.rebuild(fieldKey, supplierMap, true)
  }

  static _addDataList (fieldKey: string, list: Array<string>, clear: boolean = true) {
    const field = $(`input[name="${fieldKey}"]`)
    const listId = `datalist_${fieldKey}`
    const listOptions = list.map(entry => `<option>${entry}</option>`).join('')

    if (clear) {
      field.val('')
      field.trigger('change')
    }

    field.attr('list', listId)
    field.after(`<datalist id="${listId}">${listOptions}</datalist>`)
  }

  static _clearDataList (fieldKey: string, list: Array<string>) {
    const field = $(`input[name="${fieldKey}"]`)
    const listId = `datalist_${fieldKey}`

    field.attr('list', listId)
    field.after(`<datalist id="${listId}"></datalist>`)
  }

  static async _handleCityAutoFillByPostalCode (event: InputEvent, clear: boolean): Promise<void> {
    const postalCode = event.target.value

    if (!postalCode || !OrderValidation._isValidPostalCode(postalCode)) {
      return
    }

    const { success, cities } = await OrderSuggestions._getSuggestions('cities', { postal_code: postalCode })
    const city = $(event.target).closest('.row').find('input[name*="_city"]')
    const cityKey = city.attr('name')

    OrderSuggestions._removeDataList(cityKey)

    if (!success || !cities || !cities.length) {
      return
    }

    if (cities.length === 1 && cities[0] !== city.val()) {
      city.val(cities[0])
      city.trigger('change')
    }
    else {
      OrderSuggestions._addDataList(cityKey, cities, clear)
    }
  }

  static async _handleStreetSuggestions (type: FieldType, event: InputEvent, clear: boolean): Promise<void> {
    if (event.target.id.includes('#index#')) {
      return
    }

    const row = $(event.target).closest('.row')
    let postalCode = ''
    let city = ''
    let query = ''

    if (type === 'postal_code') {
      postalCode = event.target.value
      city = row.find('input[name*="_city"]').val()
      query = row.find('input[name*="_street"]').val()
    }
    else if (type === 'street') {
      postalCode = row.find('input[name*="_postal_code"]').val()
      city = row.find('input[name*="_city"]').val()
      query = event.target.value
    }
    else {
      postalCode = row.find('input[name*="_postal_code"]').val()
      city = event.target.value
    }

    if (!postalCode || !city || !OrderValidation._isValidPostalCode(postalCode)) {
      return
    }


    const { success, streets } = await OrderSuggestions._getSuggestions('streets', { postal_code: postalCode, 
                                                                                     city: city, 
                                                                                     query: query })

    const streetKey = row.find('input[name*="_street"]').attr('name')

    OrderSuggestions._removeDataList(streetKey)

    if (!success || !streets || !streets.length) {
      return
    }

    OrderSuggestions._addDataList(streetKey, streets, clear)
  }

  static _handleStreetSuggestionsByPostalCode = OrderSuggestions._handleStreetSuggestions.bind(this, 'postal_code')
  static _handleStreetSuggestionsByCity = OrderSuggestions._handleStreetSuggestions.bind(this, 'city')
  static _handleStreetSuggestionsByStreet = OrderSuggestions._handleStreetSuggestions.bind(this, 'street')

  static async _handleCitySuggestionsOnFocus (event: InputEvent) {
    const target = $(event.target).closest('.row').find('input[name*="_postal_code"]').get(0)

    await OrderSuggestions._handleCityAutoFillByPostalCode({ target }, false)
  }

  static async _handleStreetSuggestionsOnFocus (event: InputEvent) {
    const target = $(event.target).closest('.row').find('input[name*="_postal_code"]').get(0)

    await OrderSuggestions._handleStreetSuggestionsByPostalCode({ target }, false)
  }

  static async _handlePreSupplierSuggestionsOnFocus (event: InputEvent) {

    const target = event.target 
    await OrderSuggestions._handlePreSupplierSuggestions({ target }, false)
  }

  //-----------------------------------------
  static async _handlePreSupplierSuggestions (event, clear: boolean): Promise<void> {


    const target = event.target

    if (event)
      if (event.target.id.includes('#index#')) {
        return
      }

    let query = "";
    const { success, suppliers } = await OrderSuggestions._getSuggestions('prevprovider', { query: query })

    const supplierKey = $(target).attr('name')

    OrderSuggestions._removeDataList(supplierKey)

    if (!success || !suppliers || !suppliers.length) {
      return
    }

    OrderSuggestions._addDataList(supplierKey, suppliers, clear)
  }
  //-----------------------------------------

  static _handlePreFilter (event: InputEvent) {
    const dataList = $(event.target).siblings('datalist')
    const value = event.target.value.toLowerCase()

    if (dataList && dataList.length) {
      dataList.children().each(function () {
        if ($(this).text().toLowerCase().indexOf(value) !== 0) {
          $(this).prop('disabled', true)
        }
        else {
          $(this).prop('disabled', false)
        }
      })
    }
  }

  static async _handleStreetFilter(event: InputEvent) {

    OrderSuggestions._clearDataList(event)
    await OrderSuggestions._handleStreetSuggestionsByStreet(event, false)
    OrderSuggestions._handlePreFilter(event)
  }

  static registerEvents () {
    $(document).on('input', 'input[name*="_postal_code"]', OrderSuggestions._handleCityAutoFillByPostalCode)
    $(document).on('change', 'input[name*="_postal_code"]', OrderSuggestions._handleStreetSuggestionsByPostalCode)
    $(document).on('change', 'input[name*="_city"]', OrderSuggestions._handleStreetSuggestionsByCity)
    $(document).on('focus', 'input[name*="_city"]', OrderSuggestions._handleCitySuggestionsOnFocus)
    $(document).on('focus', 'input[name*="_street"]', OrderSuggestions._handleStreetSuggestionsOnFocus)

    $(document).on('input', 'input[name*="_street"]', OrderSuggestions._handleStreetFilter)
    $(document).on('change', 'input[name*="_street"]', OrderSuggestions._handlePreFilter)

    //$(document).on('focus','input[name*="_pre_supplier"]',OrderSuggestions._handlePreSupplierSuggestionsOnFocus )
    //$(document).on('input','input[name*="_pre_supplier"]',OrderSuggestions._handlePreFilter )

    let $supplierFields = $('input[name*="_pre_supplier"]').not('input[name*="customer_number"]');

    if ($supplierFields.length > 0) {
      OrderSuggestions.initPreSupplierDropdown($supplierFields)
    }

    //$supplierFields.on('focus', OrderSuggestions._handlePreSupplierSuggestionsOnFocus )
    //$supplierFields.on('input', OrderSuggestions._handlePreFilter )

    /*
    supplierFields.each(function(index,e) {
      e.on('focus', OrderSuggestions._handlePreSupplierSuggestionsOnFocus)
      e.on('input', OrderSuggestions._handlePreFilter)
      if (window.location.href.indexOf("step=4") != -1)
        OrderSuggestions._handlePreSupplierSuggestions(null,true);
    })
    //supplierField.on('change', OrderSuggestions._handlePreFilter)
    */

    //OrderSuggestions._handlePreSupplierSuggestionsOnFocus)

  }

  static async getsCitiesByPostalCode (postalCode: string): Promise<boolean> {
    const { success, cities } = await OrderSuggestions._getSuggestions('cities', { postal_code: postalCode })

    return success && cities && cities.length
  }
}
